import { get, post, put, del } from '@api/request';

export const fetchSmartListModules = async (
  { userService },
  authenticationToken,
) => {
  const url = `${userService}/trueprodigy/smartlistmodules`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchAllAppraisalUsers = async (
  { userService },
  authenticationToken,
) => {
  const url = `${userService}/trueprodigy/appraisalusers`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchAllAppraisalRoles = async (
  { userService },
  authenticationToken,
) => {
  const url = `${userService}/trueprodigy/appraisalroles`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchSmartListGroups = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codes?type=Smart%20List&name=Group`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchSmartList = async (
  { appraisalService },
  authenticationToken,
  { smartListId },
) => {
  const url = `${appraisalService}/appraisal/smartlist/${smartListId}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertSmartList = async (
  { appraisalService },
  authenticationToken,
  { data },
) => {
  const url = `${appraisalService}/appraisal/smartlists`;
  const { body } = await post(authenticationToken, url, data);
  return body;
};

export const updateSmartList = async (
  { appraisalService },
  authenticationToken,
  { smartListId, data },
) => {
  const url = `${appraisalService}/appraisal/smartlist/${smartListId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

export const updateSmartListTags = async (
  { appraisalService },
  authenticationToken,
  { smartListId, tags },
) => {
  const url = `${appraisalService}/appraisal/smartlist/${smartListId}/tags`;
  const { body } = await put(authenticationToken, url, { tags });
  return body;
};

export const fetchUserAccess = async (
  { appraisalService },
  authenticationToken,
  { smartListId },
) => {
  const url = `${appraisalService}/appraisal/smartlist/${smartListId}/useraccess`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertUserAccess = async (
  { appraisalService },
  authenticationToken,
  { smartListId, data },
) => {
  const url = `${appraisalService}/appraisal/smartlist/${smartListId}/useraccess`;
  const { body } = await post(authenticationToken, url, data);
  return body;
};

export const deleteUserAccess = async (
  { appraisalService },
  authenticationToken,
  { smartListUserId },
) => {
  const url = `${appraisalService}/appraisal/smartlist/useraccess/${smartListUserId}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchRoleAccess = async (
  { appraisalService },
  authenticationToken,
  { smartListId },
) => {
  const url = `${appraisalService}/appraisal/smartlist/${smartListId}/roleaccess`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertRoleAccess = async (
  { appraisalService },
  authenticationToken,
  { smartListId, data },
) => {
  const url = `${appraisalService}/appraisal/smartlist/${smartListId}/roleaccess`;
  const { body } = await post(authenticationToken, url, data);
  return body;
};

export const deleteRoleAccess = async (
  { appraisalService },
  authenticationToken,
  { smartListRoleId },
) => {
  const url = `${appraisalService}/appraisal/smartlist/roleaccess/${smartListRoleId}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const insertParameter = async (
  { appraisalService },
  authenticationToken,
  { smartListId, data },
) => {
  const url = `${appraisalService}/appraisal/smartlist/${smartListId}/parameters`;
  const { body } = await post(authenticationToken, url, data);
  return body;
};

export const updateParameter = async (
  { appraisalService },
  authenticationToken,
  { smartListParameterId, data },
) => {
  const url = `${appraisalService}/appraisal/smartlistparameter/${smartListParameterId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

export const deleteParameter = async (
  { appraisalService },
  authenticationToken,
  { smartListParameterId },
) => {
  const url = `${appraisalService}/appraisal/smartlistparameter/${smartListParameterId}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchAllParameters = async (
  { appraisalService },
  authenticationToken,
  { smartListId },
) => {
  const url = `${appraisalService}/appraisal/smartlist/${smartListId}/parameters`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const executeQueryPreview = async (
  { appraisalService },
  authenticationToken,
  {
    smartListId,
    page = 1,
    pageSize = 50,
    parameterList,
    previewQuery = 1,
    queryOnly = 0,
    pIDQuery = 0,
    excelExport = 0,
  },
) => {
  const url =
    `${appraisalService}/appraisal/smartlist/${smartListId}/executequery` +
    `?page=${page}&pageSize=${pageSize}`;
  const { body } = await post(authenticationToken, url, {
    parameterList,
    previewQuery,
    queryOnly,
    pIDQuery,
    excelExport,
  });
  return body;
};

export const executeQueryDownload = async (
  { appraisalService },
  authenticationToken,
  {
    smartListId,
    page = 1,
    pageSize = 50,
    parameterList,
    previewQuery = 1,
    queryOnly = 0,
    pIDQuery = 0,
    excelExport = 1,
  },
) => {
  const url =
    `${appraisalService}/appraisal/smartlist/${smartListId}/executequery` +
    `?page=${page}&pageSize=${pageSize}`;
  const { body } = await post(
    authenticationToken,
    url,
    {
      parameterList,
      previewQuery,
      queryOnly,
      pIDQuery,
      excelExport,
    },
    {
      outputType: 'bytearray',
    },
  );
  let blob = new Blob([body], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = 'smart-list-export.xlsx';

  link.click();
  window.URL.revokeObjectURL(link.href);
};

export const deleteSmartList = async (
  { appraisalService },
  authenticationToken,
  { smartListId },
) => {
  const url = `${appraisalService}/appraisal/smartlist/${smartListId}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export async function fetchSmartListTypes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/config/smartlisttype`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSmartListSearchConfig(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/config/smartlistsearch`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSmartListSearchConfigResults(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/config/smartlistsearchresults`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function searchSmartList(
  { appraisalService },
  authenticationToken,
  { page = 1, pageSize = 10, sortField, sortDirection, payload },
) {
  let url = `${appraisalService}/appraisal/smartlist/search?page=${page}&pageSize=${pageSize}`;
  if (sortField) {
    url = `${url}&sortField=${sortField}`;
  }
  if (sortDirection) {
    url = `${url}&sortDirection=${sortDirection}`;
  }
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function searchValidationSmartList(
  { appraisalService },
  authenticationToken,
  { page = 1, pageSize = 10, sortField, sortDirection, payload },
) {
  let url = `${appraisalService}/appraisal/smartlist/search?page=${page}&pageSize=${pageSize}`;
  if (sortField) {
    url = `${url}&sortField=${sortField}`;
  }
  if (sortDirection) {
    url = `${url}&sortDirection=${sortDirection}`;
  }
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function insertUserFavorite(
  { appraisalService },
  authenticationToken,
  { smartListId },
) {
  const url = `${appraisalService}/appraisal/smartlist/${smartListId}/userfavorite`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function deleteUserFavorite(
  { appraisalService },
  authenticationToken,
  { smartListId },
) {
  const url = `${appraisalService}/appraisal/smartlist/${smartListId}/userfavorite`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export const fetchMostCurrentProperty = async (
  { appraisalService },
  authenticationToken,
  { pid },
) => {
  const url = `${appraisalService}/appraisal/property/${pid}/mostcurrent`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const executeSmartListDownloadHistory = async (
  { appraisalService },
  authenticationToken,
  { smartListId, parameterList },
) => {
  const url = `${appraisalService}/appraisal/smartlist/${smartListId}/downloadhistory`;
  const { body } = await post(authenticationToken, url, { parameterList });
  return body;
};

export const fetchSmartListDownloadHistory = async (
  { appraisalService },
  authenticationToken,
  { smartListId, page, pageSize },
) => {
  const url = `${appraisalService}/appraisal/smartlist/${smartListId}/downloadhistory?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const downloadSmartListDownloadHistoryFile = async (
  { exportService },
  authenticationToken,
  { s3ID, newWindow = false },
) => {
  const url = `${exportService}/export/fileurl/${s3ID}`;
  const { body } = await get(authenticationToken, url);

  const anchor = document.createElement('a');
  anchor.style.display = 'none';
  document.body.appendChild(anchor);

  const response = await fetch(body);
  const blob = await response.blob();
  const objectUrl = window.URL.createObjectURL(blob);
  anchor.href = objectUrl;
  anchor.download = s3ID;
  if (newWindow) {
    anchor.target = '_blank';
  }
  anchor.click();
  window.URL.revokeObjectURL(objectUrl);
  document.body.removeChild(anchor);

  return body;
};
